import React from 'react';

import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';
import RadioGroup from 'ha/components/next/FormFields/RadioGroup';

interface Props {
  value: SearchFilters.RecentlyAddedFilterValue;
  onChange: (value: SearchFilters.RecentlyAddedFilterValue) => void;
}

interface RecentlyAddedOption {
  value: SearchFilters.RecentlyAddedValue;
  title: string;
  dataTestLocator?: string;
}

export const RecentlyAddedFilter: React.FC<Props & IntlProps> = ({
  value,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="RecentlyAddedFilter Title">
      {T('Recently added listings')}
    </Typography.ParagraphTitle>

    <RadioGroup
      input={{
        value: value as string,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value as SearchFilters.RecentlyAddedFilterValue),
      }}
      options={
        [
          {
            value: '1-day',
            title: T('Last 24 hours'),
            dataTestLocator: 'Filter Last 24',
          },
          {
            value: '3-days',
            title: T('Last 3 days'),
            dataTestLocator: 'Filter Last 3',
          },
          {
            value: '7-days',
            title: T('Last 7 days'),
            dataTestLocator: 'Filter Last 7',
          },
          {
            value: '14-days',
            title: T('Last 14 days'),
            dataTestLocator: 'Filter Last 14',
          },
        ] as RecentlyAddedOption[]
      }
      data-test-locator="RecentlyAddedFilter Controls"
    />
  </React.Fragment>
);

export default withIntl(RecentlyAddedFilter);
